












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    availableEnemYears: {
      type: Array as PropType<string[]>,
      required: true,
    },
    selectedEnemYear: {
      type: String,
      default: '',
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.availableEnemYears.map((year, index) => ({
        key: index,
        content: { title: year, titleSize: 'h3' },
      }));

      return items;
    },
    selected(): number {
      return this.availableEnemYears.indexOf(this.selectedEnemYear);
    },
  },
  methods: {
    selectedHandler(selectedCard: CardInfo) {
      setTimeout(() => {
        this.$emit('selected', selectedCard.content.title);
      }, 300);
    },
  },
});
